module.exports = __webpack_public_path__ + "static/img/loginImg.e33b17d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/loginImg.svg
// module id = Id7z
// module chunks = 51